import { MultimediaResponse } from "chaild-api/lib";

/**
 * 購入済み (コンビニ決済の入金待ちを含む) で削除できないコンテンツかを判定する
 */
export const isPurchasedContent = (content: MultimediaResponse): boolean => {
  // hasUnpaidOrder は chaild-api の型を更新する前でも動くよう任意項目として扱う
  const { hasUnpaidOrder } = content as MultimediaResponse & { hasUnpaidOrder?: boolean };
  return content.purchasedCount > 0 || hasUnpaidOrder === true;
};
